import React from "react";
import styles from "./VideoSearchResults.module.css";
import {VideoSearchResultList} from "./VideoSearchResultList";
import {SearchHit} from "../../SearchResult";
import PuiTypography from "../../../../components/elements/PuiTypography";
import useResponsive from "../../../../common/useResponsive";

interface VideoSearchResultsProps {
    hits?: SearchHit[];
}

export function VideoSearchResults({hits}: VideoSearchResultsProps) {
    const { isMobile } = useResponsive()
    return (
        <div className={styles.root}>
            <div className={styles.meta}>
                {
                    hits &&
                    <div className={styles.title}>
                        <PuiTypography size={isMobile? 16 : 24} bold={true}>{`${hits.length} Result(s)`}</PuiTypography>
                    </div>
               }
            </div>

            <div className={styles.listArea}>
                <VideoSearchResultList hits={hits}/>
            </div>
        </div>
    );
}
